// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { fetchWrapper } from 'helpers/api'

export const fetchBands = () => fetchWrapper('/bands')

export const fetchDomains = () => fetchWrapper('/domains')

export const fetchLicenseBases = () => fetchWrapper('/license-bases')

export const fetchRadioServices = () => fetchWrapper('/radio-services')

export const fetchPathStatuses = () => fetchWrapper('/path-statuses')

export const fetchSegmentStatuses = () => fetchWrapper('/segment-statuses')

export const fetchStates = () => fetchWrapper('/states')

export const fetchStationClasses = () => fetchWrapper('/station-classes')
